import { MenuDocument, MenuItem } from "features/editor/MenuDocumentModel";
import { CreateMenuRequest } from "features/menu/createMenuSlice";
import { AlgoliaWine } from "features/winepicker/winePickerModel";
import { AppDispatch } from "lib/redux/store";
import { LabelDocument } from "./LabelDocumentModel";
import { DocumentHandler, DocumentTypeHandler, DocumentTypeTranslations, EditableItemProps, ElementStyling } from "features/editor/DocumentHandler";
import { EditorItem } from "features/editor/editorUtils";
import { labelEditorActions } from "./labelEditorSlice";
import { range } from "ramda";


export class LabelDocumentTypeHandler extends DocumentTypeHandler {
    createEmptyDocument(createMenuRequest: CreateMenuRequest): MenuDocument {
        if (!createMenuRequest.args?.template) {
            throw new Error('cannot create label, template not specified');
        }
        const template = createMenuRequest.args.template;
        const doc: LabelDocument = {
            type: 'label',
            language: createMenuRequest.language,
            format: 'custom',
            template: template,
            coverPage: null,
            printMode: "singlepages",
            displayFooter: false,
            showAppellation: false,
            showYear: true,
            degu: false,
            pages: [],
            sizes: ["1dl", "2dl", "5dl", "Flasche"]
        };
        return doc;
    }
    getTranslations(): DocumentTypeTranslations {
        // TODO set translations
        return {
            successEmailFirstLine: "mainpage.create.label.label",
            createMenuTitle: "mainpage.create.label.label",
            createMenuName: "mainpage.create.label.label"
        }
    }
}

export class LabelDocumentHandler extends DocumentHandler {
    getPageStyling(mode: "preview" | "pdf"): ElementStyling {
        let className = "";
        const doc = this.document as LabelDocument;
        return {
            className,
            style: {
                width: doc.template.size.width+"mm",
                height: (doc.template.size.height-0.25)+"mm"
            }
        }
    }
    handleAddWines(algoliaWines: AlgoliaWine[], dispatch: AppDispatch) {}
    shouldBreakPageAfterItem(item: MenuItem): boolean {return true}
    getEditableItemPropsAndStyling(item: EditorItem<MenuItem>, isFocused: boolean): EditableItemProps {
        const styles = super.getEditableItemPropsAndStyling(item, isFocused);
        styles.className += " outline-offset-8 rounded"
        if (isFocused) {
            styles.style = {
                ...styles.style,
                outlineOffset: '3mm'
            }
        }
        return styles;
    }
    getEditablePageWrapperStyling(): ElementStyling {
        const styling = super.getEditablePageWrapperStyling();
        styling.className += " py-4 gap-4";
        return styling;
    }
    isItemSortable(item: MenuItem): boolean {
        return false;
    }
    unfocusActiveItem(dispatch: AppDispatch) {
        dispatch(labelEditorActions.unfocusActiveItem());
    }
    
    getNumberOfPrints(): number[] {
        return range(2, 10).map(i=>i*18);
    }
}
